import Users from '../tabs/settings/components/users/Users'

export const settingsRoutes = [
  {
    path: 'users',
    name: 'Users',
    component: Users,
  },
]
